import GravityV3Adapter from 'teacher-ui-client/adapters/gravity/v3-adapter'

export default class PartnerAdapter extends GravityV3Adapter {}
